export default __webpack_public_path__ + "static/media/check-mark-gray.be4a8745.svg";